import './work-details.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {GetWorks, SendMessage} from "../../../redux/actions";
import {connect} from "react-redux";
import {Link, useParams} from "react-router-dom";
import {getUrlWithLocal} from "../../../utils/getUrlWithLocal";
import React, {useEffect, useState, useCallback, useRef} from "react";
import {OptionsCheckedIcon, SliderLeftIcon, SliderRightIcon} from "../../../assets/images";
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {Navigation, Pagination,Autoplay} from 'swiper/modules';


function WorkDetails(props) {
    const {works,staticTexts,selectedLanguage} = props
    const [work, setWork] = useState(null);
    const params = useParams();
    const [activeIndex,setActiveIndex] = useState(false);
    const sliderRef = useRef(null);

    useEffect(() => {
        setWork(works?.find((item) => item.id === params.id));
    },[params?.id,works])


    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        //@ts-ignore
        sliderRef.current?.swiper?.slidePrev();
    }, []);

    useEffect(()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    },[])

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        //@ts-ignore
        sliderRef.current?.swiper?.slideNext();
    }, []);

    return <div className="work_details_wrapper">
        <div className={'works_details_header_block'}>
            <div className={'works_details_header_titles'}>
                <Link to={getUrlWithLocal('/home')}>{staticTexts?.works_general_link_text || 'Главная'}  /</Link>
                <Link to={getUrlWithLocal('/works/all')}>{staticTexts?.works_page_link_text || 'Проекты'}  /</Link>
                <span className={'works_name'}>{work?.title}</span>
            </div>
        </div>
        <div className={'works_details_content'}>
            <div className={'works_details_content_title'}>
                {work?.title}
            </div>
            <div className={'works_details_info'}>
                <div className={'works_details_left_block'}>
                    {
                        work?.mediaArray?.length > 0 ? <div className={'works_details_img_list'}>
                                {
                                    work?.mediaArray?.length > 1 ?  <button onClick={handlePrev} className={'work_prev_btn'}>
                                        <SliderLeftIcon/>
                                    </button> : ''
                                }
                            <Swiper
                                effect={'flip'}
                                watchSlidesProgress={true}
                                slidesPerView={1}
                                pagination={false}
                                modules={[Autoplay,Navigation, Pagination]}
                                navigation={false}
                                loop={true}
                                allowTouchMove={true}
                                autoplay={{
                                    delay: 2000,
                                    disableOnInteraction: false,
                                }}
                                ref={sliderRef}
                                onRealIndexChange={(swiper) => {
                                    setActiveIndex(swiper.realIndex)
                                }}
                            >

                                {
                                    work?.mediaArray?.map((item, index) => {
                                        return <SwiperSlide key={index} className={'work_img_wrapper'}>
                                            <img src={generateFileMediaUrl(item?.path)} alt="" className={'work_img'}/>
                                        </SwiperSlide>
                                    })
                                }
                            </Swiper>
                            {
                                work?.mediaArray?.length > 1 ? <button onClick={handleNext} className={'work_next_btn'}>
                                    <SliderRightIcon/>
                                </button> : ''
                            }
                        </div> : <div className={'works_details_img'}>
                            <img src={generateFileMediaUrl(work?.mediaMain?.path)} alt=""/>
                        </div>
                    }
                </div>
                <div className={'works_details_right_block'}>
                    <span className={'work_type'}>{work?.isFinished ? staticTexts?.works_finished_projects_type : staticTexts?.works_not_finished_projects_type}</span>
                    <div className={'works_details_description'} dangerouslySetInnerHTML={{__html: work?.description}}/>

                    <div className={'works_details_options_block'}>
                        {
                            work?.options.length > 1 ? work?.options?.map((option, i) => {
                                return <div className={'works_details_options_item'} key={i}>
                                    <OptionsCheckedIcon/>
                                    <div className={'options_item_info'}>
                                        <span className={'options_item_title'}>{option?.title}</span>
                                        <span className={'options_item_description'}>{option?.subTitle}</span>
                                    </div>
                                </div>
                            }) : ''
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
}
const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'selectedLanguage',
    'works'
]);

const mapDispatchToProps = {
    SendMessage,
    GetWorks
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkDetails);